export default __webpack_public_path__ + "static/media/assemble.9e459518.mp4";